module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar",
    attrs: {
      "id": "slider"
    }
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "user-panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pull-left info"
  }, [_c('p', [_vm._v(_vm._s(_vm.currentUser.name))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle",
    style: (("color:" + (_vm.currentUser.state.color)))
  }), _vm._v(" " + _vm._s(_vm.currentUser.state.name))])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "sidebar-menu"
  }, _vm._l((_vm.slideMenuItems), function(item) {
    return _c('va-slide-item', {
      attrs: {
        "type": item.type,
        "isHeader": item.isHeader,
        "icon": item.icon,
        "name": item.name,
        "badge": item.badge,
        "items": item.items,
        "router": item.router,
        "link": item.link
      }
    })
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left image"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": require("admin-lte/dist/img/user2-160x160.jpg"),
      "alt": "User Image"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "sidebar-form",
    attrs: {
      "action": "#",
      "method": "get"
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "q",
      "placeholder": "Search..."
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-flat",
    attrs: {
      "type": "submit",
      "name": "search",
      "id": "search-btn"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b51badf!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Slider.vue
// module id = 527
// module chunks = 1